import type {
	UsageLimit,
	UsageLimitsData,
} from '@atlassian/jira-growth-data-usage/src/common/types.tsx';
import { useDataUsage, getCachedDataUsage } from '@atlassian/jira-growth-data-usage/src/utils.tsx';
import { PACKAGE_NAME } from '../../common/constants.tsx';
import { ELIGIBLE_STORAGE_RATIO_THRESHOLD_TO_SEE_MODAL } from './constants.tsx';

function getJswStorageLimit(response?: UsageLimitsData | null): UsageLimit | undefined {
	return response?.limits.find((limit) => limit.product.startsWith('ari:cloud:jira-software'));
}

function getStorageRatio(usageLimit: UsageLimit | undefined) {
	return usageLimit && !usageLimit.total.unlimited
		? usageLimit.total.used / usageLimit.total.allowed
		: undefined;
}

export function useJswStorageUsage({ skip }: { skip: boolean }) {
	const cachedUsageLimit = getJswStorageLimit(getCachedDataUsage());
	const storageRatioFromCachedUsageLimit = getStorageRatio(cachedUsageLimit);

	const shouldUseCache =
		storageRatioFromCachedUsageLimit !== undefined &&
		storageRatioFromCachedUsageLimit < ELIGIBLE_STORAGE_RATIO_THRESHOLD_TO_SEE_MODAL;

	const { data } = useDataUsage({
		skip,
		shouldUseCache,
		caller: PACKAGE_NAME,
		teamName: 'jlove-makkuro',
	});

	const jswStorageLimit = getJswStorageLimit(data);
	const jswStorageRatio = getStorageRatio(jswStorageLimit);

	return {
		jswStorageRatio,
		jswStorageLimit,
	};
}
